import { Tr069DeviceConstants } from "../constants/tr069device.constants";

const Tr069DeviceReducer = (state, action) => {
  switch (action.type) {
    case Tr069DeviceConstants.GET_DEVICE_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case Tr069DeviceConstants.GET_DEVICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        device: action.payload,
      };
    case Tr069DeviceConstants.GET_DEVICE_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        device: null,
      };

    case Tr069DeviceConstants.LINK_DEVICE_REQUEST:
    case Tr069DeviceConstants.UNLINK_DEVICE_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case Tr069DeviceConstants.LINK_DEVICE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        device: action.payload,
      };
    case Tr069DeviceConstants.UNLINK_DEVICE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        device: null,
        tasks: [],
      };
    case Tr069DeviceConstants.LINK_DEVICE_FAILURE:
    case Tr069DeviceConstants.UNLINK_DEVICE_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        hasError: true,
      };

    case Tr069DeviceConstants.GET_DEVICE_TASKS_REQUEST:
      return {
        ...state,
        isLoadingTasks: true,
      };
    case Tr069DeviceConstants.GET_DEVICE_TASKS_SUCCESS:
      return {
        ...state,
        isLoadingTasks: false,
        tasks: action.payload,
      };
    case Tr069DeviceConstants.GET_DEVICE_TASKS_FAILURE:
      return {
        ...state,
        isLoadingTasks: false,
        hasError: true,
      };

    case Tr069DeviceConstants.CREATE_TASK_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case Tr069DeviceConstants.CREATE_TASK_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case Tr069DeviceConstants.CREATE_TASK_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        hasError: true,
      };

    default:
      return state;
  }
};

export default Tr069DeviceReducer;
